import { map } from 'nanostores';

export const $listScrollPositions = map<Record<string, number>>({});

export function useListScrollPosition(key: string) {
  const restoreScrollLeft = (element: HTMLElement) => {
    element.scrollLeft = $listScrollPositions.get()[key] ?? 0;
  };

  const saveScrollLeft = (scrollLeft: number) => {
    $listScrollPositions.setKey(key, scrollLeft);
  };

  return { restoreScrollLeft, saveScrollLeft };
}
